<template>
  <section>
    <el-card shadow="never">
      <div class="top-bar" style="display: flex">
        <el-input
          placeholder="输入商品名称查询"
          v-model="searchVal"
          @change="search()"
          style="width: 210px; margin-right: 20px"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <el-table
        :data="tableData"
        max-height="500"
        ref="table"
        style="width: 100%"
      >
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="total_price" align="center" label="商品价格">
          <template slot-scope="scope">
            <span v-if="scope.row.min_price == scope.row.max_price">C${{scope.row.min_price}}</span>
            <span v-else>C${{ (scope.row.min_price*1).toFixed(2) }} ~ C${{(scope.row.max_price *1).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" align="center" label="折扣价格">
          <template slot-scope="scope">
            <span v-if="scope.row.off == 0">--</span>
            <span v-else>
              <span v-if="scope.row.min_price == scope.row.max_price">C${{(scope.row.min_price * scope.row.off / 100).toFixed(2)}}</span>
              <span v-else>
                C${{ (scope.row.min_price * scope.row.off / 100).toFixed(2) }} ~ C${{(scope.row.max_price * scope.row.off / 100).toFixed(2)}}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态值">
          <template slot-scope="scope">
            <el-link type="success" v-if="scope.row.status == 1">已上架</el-link>
            <el-link type="danger"  v-if="scope.row.status == 2">已下架</el-link>
            <el-link type="info"    v-if="scope.row.status == 3">待审核</el-link>
            <el-link type="success" v-if="scope.row.status == 4">待上架</el-link>
            <el-link type="danger"  v-if="scope.row.status == 5">已回收</el-link>
            <el-link type="info"    v-if="scope.row.status == 6">未通过</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" align="center" label="排序">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sort"
              @change="handleSetSort(scope.row.id, scope.row.sort)"
              style="width: 50px"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="编辑">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              plain
              @click="handleDelRem(scope.row.id)"
              >移除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        style="padding: 10px"
        :total="total"
        :page-size="size"
        @current-change="loadMore"
      />
    </el-card>
  </section>
</template>


<script>
import {
  get_pre_goods,
  del_rem_presale,
  set_sort_presale,
} from "@/api/market.js";
import MImg from "@/components/Image";

export default {
  components: { MImg },
  props: {
    mapId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tableData: [],
      searchVal: "",
      total: 0,
      page: 1,
      size: 50,
    };
  },
  methods: {
    // 主题商品列表
    getData() {
      let params = {
        flag: 2,
        page: this.page,
      };
      if (this.searchVal != "") {
        params.search = this.searchVal;
      }
      get_pre_goods(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page - 0;
        } else {
          this.tableData = [];
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    loadMore(page) {
      this.page = page;
      this.getData();
    },
    handleDelRem(id) {
      // 移除推荐
      del_rem_presale(id).then((res) => {
        this.tableData = this.tableData.filter((item) => {
          return item.id != id;
        });
        this.$message({ type: "success", message: res.msg, duration: 1500 });
      });
    },
    handleSetSort(id, sort) {
      // 设置排序
      set_sort_presale(id, { sort: sort }).then((res) => {
        this.$message({ type: "success", message: res.msg, duration: 1500 });
        this.getData();
      });
    },
  },
  watch: {
    mapId: function () {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
section {
  .top-btn {
    width: 80px;
    margin-right: 15px;
  }
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
}
</style>